import type { ISectionsList } from '@bprotsyk/aso-core/lib/offers/list';

export interface SectionsListItem {
  id: number;
  name: string;
  sectionsList: ISectionsList;
}

export const createSectionsListDraft = (lists: SectionsListItem[]): SectionsListItem => {
  const nextId = Math.max(
    ...lists.flatMap((list) => [Number(list.id) || 0, Number(list.sectionsList.id) || 0]),
    0
  ) + 1;
  const name = `List ${nextId}`;

  return {
    id: nextId,
    name,
    sectionsList: {
      id: nextId,
      name,
      offerwallType: 'MFO',
      content: [{
        sectionId: 1,
        offerStatesOrdered: {}
      }]
    }
  };
};

export const renameSectionsListDraft = (
  draft: SectionsListItem,
  value: string
): SectionsListItem => {
  const name = value.trim();
  if (!name) return draft;

  return {
    ...draft,
    name,
    sectionsList: {
      ...draft.sectionsList,
      name
    }
  };
};

export const buildSectionsListSavePayload = (
  sectionsList: ISectionsList,
  value: string
): ISectionsList => ({
  ...sectionsList,
  id: sectionsList.id,
  name: value.trim(),
  offerwallType: 'MFO'
});
